<template>
  <div class="auth-page">
    <div class="auth-container">
      <div class="auth-logo">
        <a href="/">
          <img :src="logoUrl" alt="SMASHING SHAPE" />
        </a>
      </div>
      
      <div class="auth-card">
        <div class="auth-header">
          <h1>Forgot Password?</h1>
          <p>Enter your email to reset your password</p>
        </div>

        <form @submit.prevent="handleSubmit" class="auth-form">
          <div class="form-group">
            <label>Email Address *</label>
            <input 
              v-model="form.email" 
              type="email" 
              placeholder="Enter your email address"
              required
              :disabled="loading"
            >
            <span v-if="errors.email" class="error">{{ errors.email[0] }}</span>
          </div>

          <button type="submit" class="btn-submit" :disabled="loading">
            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fas fa-paper-plane"></i>
            {{ loading ? 'Sending...' : 'Send Reset Link' }}
          </button>
        </form>

        <div class="auth-footer">
          <p>Remember your password? 
            <a href="/login">Login</a>
          </p>
        </div>

        <div v-if="successMessage" class="rounded-md border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>
        
        <div v-if="errorMessage" class="rounded-md border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {{ errorMessage }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ForgotPassword',
  props: {},
  data() {
    return {
      logoUrl: '/logos/logodark.svg',
      form: {
        email: ''
      },
      errors: {},
      loading: false,
      successMessage: '',
      errorMessage: ''
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true
      this.errors = {}
      this.errorMessage = ''
      this.successMessage = ''
      
      try {
        const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
        
        const response = await fetch('/password/forgot', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify(this.form)
        })
        
        const data = await response.json()
        
        if (response.ok) {
          this.successMessage = data.message || 'Password reset link sent! Please check your email.'
          this.form.email = ''
        } else {
          if (data.errors) {
            this.errors = data.errors
          }
          this.errorMessage = data.message || 'Failed to send reset link. Please try again.'
        }
      } catch (error) {
        this.errorMessage = 'An error occurred. Please try again.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

